import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { audienceErrorHandler } from '../helpers';

export const WithCampaignAudienceRepository = ({
  WrappedComponent, i18n,
}) => (
  <CampaignOData
    call={({ currentCampaign }) => currentCampaign.AudienceAssociations['Default.GridData'].$makeCall({
        query: {
          top: 3,
          select: ['AudienceCriterion', 'Level'],
          orderby: { 'AudienceCriterion/AudienceName': -1 },
        },
        payload: {
          gridDataParameters: {
            DateRange: {
              StartDate: i18n.formatDate(new Date(), {
                raw: 'yyyy-MM-dd',
              }),
              EndDate: i18n.formatDate(new Date(), {
                raw: 'yyyy-MM-dd',
              }),
            },
          },
        },
      })
    }
    escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : null)}
    fallback={(<WrappedComponent audienceFromOData={{ dataNotReady: true }} />)}
    onError={audienceErrorHandler(WrappedComponent, i18n)}
  >
    { audienceFromOData =>
      (<WrappedComponent audienceFromOData={audienceFromOData} />) }
  </CampaignOData>
);

WithCampaignAudienceRepository.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
